// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ApiFilledSvg from "@ant-design/icons-svg/es/asn/ApiFilled";
import AntdIcon from '../components/AntdIcon';

var ApiFilled = function ApiFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ApiFilledSvg
  }));
};

ApiFilled.displayName = 'ApiFilled';
export default React.forwardRef(ApiFilled);